import React, { createContext, useState, useContext } from "react";

const WalletContext = createContext();

export const WalletProvider = ({ children }) => {
    const [wallet, setWallet] = useState({
        anchorId: null,       
        dsaCode: null, 
        dsaId: null,
        subAnchorWalletId: null,
        anchorWalletId: null    
    });

    return (
        <WalletContext.Provider value={{ wallet, setWallet }}>
            {children}
        </WalletContext.Provider>
    );
};

export const useWallet = () => useContext(WalletContext);